import type { CuratorEventItemDTO } from '@musinsa/services-curator';

export type CuratorEventRowItem = CuratorEventItemDTO & { _index: number };

/**
 * 이미지가 있는 이벤트만 남기고, 원본 순서의 인덱스를 붙인 뒤 n개씩 묶습니다.
 */
export const chunkEventsWithIndex = (
  events: CuratorEventItemDTO[],
  chunkSize: number,
): CuratorEventRowItem[][] => {
  const withIndex: CuratorEventRowItem[] = [];
  let visualIndex = 0;
  for (const event of events) {
    if (!event.image?.length) {
      continue;
    }
    withIndex.push({ ...event, _index: visualIndex });
    visualIndex += 1;
  }
  const chunks: CuratorEventRowItem[][] = [];
  for (let i = 0; i < withIndex.length; i += chunkSize) {
    chunks.push(withIndex.slice(i, i + chunkSize));
  }
  return chunks;
};
